import * as React from 'react';
import { ArticleHeading3, ArticleParagraph2 } from '@cian/ui-kit';
import classNames from 'clsx';

import * as styles from './promoIntro.css';
import { PromoBlackFridayBadge } from '../PromoBlackFridayBadge';

export interface IPromoItemProps {
  dueDate?: string;
  name: string;
  onClick(): void;
  icon?: string | null;
  subtitle?: string;
  isBlackFridayPromo: boolean;
}

export const PromoIntro = ({ name, dueDate, onClick, subtitle, icon, isBlackFridayPromo }: IPromoItemProps) => {
  return (
    <div className={styles['promo']} onClick={onClick} data-testid="PromoIntro">
      {icon && (
        <div className={classNames(styles['icon'])}>
          <img alt={name} width="56" height="56" src={icon} className={styles['image']} />
          {isBlackFridayPromo && (
            <div className={styles['black-friday-badge']}>
              <PromoBlackFridayBadge size={22} />
            </div>
          )}
        </div>
      )}
      <div className={styles['description']}>
        <ArticleHeading3 color="current_color">{name}</ArticleHeading3>
        {(subtitle || dueDate) && (
          <ArticleParagraph2 color="gray60_100">
            {subtitle && <span className={styles['subtitle']}>{subtitle}</span>}
            {dueDate && <span className={styles['subtitle']}>{dueDate}</span>}
          </ArticleParagraph2>
        )}
      </div>
    </div>
  );
};
